import { DETERMINAR_PAGINA_ATUAL_PEDIDO } from '../types'

export default function determinarPaginaAtualPedido (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_PEDIDO,
    payload: paginaAtual
  }
}
